import { gql } from '@apollo/client'
import { eventListFragment } from '~/graphql/fragments'

export const GET_USER_EVENTS = gql`
  query getUserEvents {
    viewer {
      id
      facebookUserEvents {
        edges {
          node {
            ...eventList
          }
        }
      }
    }
  }

  ${eventListFragment}
`
